import { render } from "./Default.vue?vue&type=template&id=621bd8ee&scoped=true"
import script from "./Default.vue?vue&type=script&lang=js"
export * from "./Default.vue?vue&type=script&lang=js"

import "./Default.vue?vue&type=style&index=0&id=621bd8ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-621bd8ee"]])

export default __exports__